module.exports = __webpack_public_path__ + "static/media/transactions.66946dc6.svg";